var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserStriped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 60,
    viewBox: "0 0 18 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_83000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.0002 0.449219C4.28564 0.449219 0.450195 4.28466 0.450195 8.99922C0.450195 13.7138 4.28564 17.5492 9.0002 17.5492C13.7148 17.5492 17.5502 13.7138 17.5502 8.99922C17.5502 4.28466 13.7148 0.449219 9.0002 0.449219ZM14.1903 14.1497C13.5348 12.8015 12.1527 11.8709 10.5532 11.8709H7.44716C5.84786 11.8709 4.46564 12.8015 3.81008 14.1497C2.49698 12.8266 1.68428 11.0062 1.68428 8.99922C1.68428 4.96524 4.96622 1.6833 9.0002 1.6833C13.0342 1.6833 16.3161 4.96524 16.3161 8.99922C16.3161 11.0062 15.5034 12.8266 14.1903 14.1497Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00023 10.643C10.8158 10.643 12.2876 9.17125 12.2876 7.3557C12.2876 5.54015 10.8158 4.06836 9.00023 4.06836C7.18468 4.06836 5.71289 5.54015 5.71289 7.3557C5.71289 9.17125 7.18468 10.643 9.00023 10.643Z",
    fill: "#7E7E7E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 24L9 59",
    stroke: "#E0E0E0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeDasharray: "5.4 5.4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_83000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserStriped);
export default __webpack_public_path__ + "static/media/user-striped.48f61dff.svg";
export { ForwardRef as ReactComponent };